"use strict";
/**
 * EntitySelection ist der Einstieg für jede Entity
 * Hier wird unterschieden, in welche Ansicht wir wechseln (TableView / EditView)
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var DataTableView_1 = __importDefault(require("../screens/DataTableView/DataTableView"));
var DataEditView_1 = __importDefault(require("../screens/DataEditView/DataEditView"));
var commonTypes_1 = require("../shared/types/commonTypes");
var react_redux_1 = require("react-redux");
var crudeActions = __importStar(require("../store/crude/crude.actions"));
var EntitySelect = function (props) {
    var params = props.match.params;
    var dispatch = react_redux_1.useDispatch();
    var entity = props.entity;
    var id = params && params.id;
    id
        ? dispatch(crudeActions.setDataDisplayMode(commonTypes_1.DataDisplayMode.edit))
        : dispatch(crudeActions.setDataDisplayMode(commonTypes_1.DataDisplayMode.list));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !id && entity &&
            react_1.default.createElement(DataTableView_1.default, { entity: entity, treeViewLevel: 0 }),
        id && entity &&
            react_1.default.createElement(DataEditView_1.default, { entity: entity, id: id, treeViewLevel: 1 })
    // <ConfigurationEditView entity={entity} />
    ));
};
exports.default = react_router_1.withRouter(EntitySelect);
